/* eslint-disable */
import styled from 'styled-components'

export default styled.div`
  border-radius: 20px;

  border: solid 1px ${props => props.border || '#ffe8d0'};
  background-color: #ffffff;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  padding: 32px 24px;
  height: 100%;
  cursor: pointer;
  transition: all 0.3s ease-in;
  box-shadow: 0 8px 20px 0 transparent;
  &:hover {
    box-shadow: 0 8px 20px 0 rgba(0, 0, 0, 0.1);
  }

  .text {
    .title {
      font-size: 24px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: center;
      color: ${props => props.color || '#ff7400'};
      margin: 35px 0;
      @media screen and (min-width: 300px) and (max-width: 768px) {
        margin: 15px 0;
      }
    }
    .desc {
      padding: 0 20px;
      font-size: 18px;
      font-weight: normal;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.61;
      letter-spacing: normal;
      text-align: center;
      color: #888888;
    }
  }
  .image {
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 120px;
      height: 120px;
      display: block;
      object-fit: contain;
    }
    @media screen and (min-width: 300px) and (max-width: 768px) {
      display: ${props =>
        props.imageResponsiveMobile ? 'none' : 'flex'}!important;
    }
  }
`
